import { render, staticRenderFns } from "./notification-dialog.vue?vue&type=template&id=ca6d30cc&scoped=true"
import script from "./notification-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-dialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./notification-dialog.vue?vue&type=style&index=0&id=ca6d30cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6d30cc",
  null
  
)

export default component.exports